export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9984.6ff5dd3e.jpg";